import React from 'react';
import { Button, Checkbox, TableCell, TableRow } from '@mui/material';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { Link } from 'react-router-dom';
import { Chat } from '../../models';

interface ChatTableRowProps {
  chat: Chat
  dark: boolean,
  selected: boolean,
  onChatSelect?: (chat: Chat) => void
}

export const ChatTableRow: React.FC<ChatTableRowProps> = ({
  chat,
  dark,
  selected,
  onChatSelect,
}) => {
  const user = useCurrentUser()

  return (
    <TableRow className={dark ? 'dark_row' : 'light_row'}>
      <TableCell style={{ padding: "0.25rem 1.25rem" }}>
        <Checkbox className="table_cell" checked={selected} onChange={() => onChatSelect?.(chat)}></Checkbox>
      </TableCell>
      <TableCell className="table_cell">
        <div className="hover-image" title={chat.name}>
          {chat.name}
        </div>
      </TableCell>
      <TableCell className="table_cell">
        {new Date(chat.createdAt).getDate()}/{new Date(chat.createdAt).getMonth()+1}/{new Date(chat.createdAt).getFullYear()}
      </TableCell>
      <TableCell>
        <div style={{ justifyContent: "space-between", display: "flex" }}>
          <Button component={Link} to={!user?.perms.p2 ? `/content/chats` : `/content/chats/${chat.id}`} disabled={!user?.perms.p2} size="small" variant="contained" color="secondary">
            Edit
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};
